module.exports = __webpack_public_path__ + "static/media/info_white.1b975aed.svg";